export default __webpack_public_path__ + "static/3-dba03a72acc306d016bc63088687b538.jpeg";